const Spinner = ({ enabled }) => {
    return enabled && (
        <div class="spinner-border spinner-border-sm text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    );
};

export default Spinner;